import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Iowa = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Iowa Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure form with 19 questions required.
        </Text>

        <Text style={styles.listItem}>
          2. Seller's Disclosure of Property Condition: Required by law.
        </Text>

        <Text style={styles.listItem}>
          3. Well Disclosure: Required if the property has a private well.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5. <Text style={styles.underline}>Radon Disclosure Fact Sheet</Text> –
          Though not required, it is recommended to disclose information
          regarding radon.
        </Text>

        <Text style={styles.listItem}>
          6.{' '}
          <Text style={styles.underline}>
            Seller Property Condition Disclosure
          </Text>{' '}
          – The seller must complete this form, which covers structural and
          material damage, environmental issues, zoning information, and other
          relevant data.
        </Text>
      </View>
    </View>
  );
};

export default Iowa;
